<template>
  <div class="bookIntro">
    <!-- 顶部大图片 -->
    <imgBigCards imgHeight="200px"></imgBigCards>

    <!-- 青色区域 -->
    <div class="box-cyan">
      <div class="cyan-background">
        <textBar :titles="getCategoryText(21) || ''"></textBar>
        <!-- 插件swiper区域-总复习 -->
        <div class="box-columnBookCards">
          <swiper
            v-if="mydata.bookListData1.length"
            direction="horizontal"
            class="inside-cardBox"
            :slidesPerView="
              mydata.bookListData1.length >= 2 ? 2 : mydata.bookListData1.length
            "
            loop
            :autoplay="{ delay: 3000, disableOnInteraction: true }"
            :navigation="false"
            :pagination="{ clickable: true }"
            :scrollbar="{ draggable: true }"
            :space-between="0"
            :centeredSlides="false"
            :modules="modules"
            effect="coverflow"
            @swiper="onSwiper"
            @mouseenter="enter"
            @mouseleave="leave"
            @slideChange="onSlideChange"
            :slidesOffsetBefore="0"
            :slidesOffsetAfter="0"
            :spaceBetween="0"
          >
            <swiper-slide
              v-for="(item, index) in mydata.bookListData1"
              :key="index"
              style="margin: 0"
            >
              <columnBookCards2
                class="column-book3"
                :info="item"
                
              >
                <!-- <template #columnBook>
                  <img class="big-img" v-complete:src="item.img_url" alt="" />
                </template> -->
                <template #line>
                  <div
                    style="
                      width: 35px;
                      border: 1px solid #ffffff99;
                      margin: 10px 0px;
                    "
                  ></div>
                </template>
              </columnBookCards2>
            </swiper-slide>
          </swiper>
          <!-- <el-button
            class="l-btn"
            :icon="ArrowLeft"
            circle
            @click="rightClick"
          ></el-button>
          <el-button
            class="r-btn"
            :icon="ArrowRight"
            circle
            @click="leftClick"
          ></el-button> -->
        </div>
      </div>
      <div class="cyan-background">
        <textBar :titles="getCategoryText(16) || ''"></textBar>
        <!-- 插件swiper区域-同步类 -->
        <div class="box-columnBookCards">
          <swiper
            v-if="mydata.bookListData2.length"
            direction="horizontal"
            class="inside-cardBox"
            :slidesPerView="
              mydata.bookListData2.length >= 2 ? 2 : mydata.bookListData2.length
            "
            loop
            :autoplay="{ delay: 3000, disableOnInteraction: true }"
            :navigation="false"
            :pagination="{ clickable: true }"
            :scrollbar="{ draggable: true }"
            :space-between="0"
            :centeredSlides="false"
            :modules="modules_1"
            effect="coverflow"
            @swiper="onSwiper_1"
            @mouseenter="enter_1"
            @mouseleave="leave_1"
            @slideChange="onSlideChange_1"
            :slidesOffsetBefore="0"
            :slidesOffsetAfter="0"
            :spaceBetween="0"
          >
            <swiper-slide
              v-for="(item, index) in mydata.bookListData2"
              :key="index"
              style="margin: 0"
            >
              <columnBookCards2
                class="column-book3"
                :info="item"
                
              >
                <!-- <template #columnBook>
                  <img class="big-img" v-complete:src="item.img_url" alt="" />
                </template> -->
                <template #line>
                  <div
                    style="
                      width: 35px;
                      border: 1px solid #ffffff99;
                      margin: 10px 0px;
                    "
                  ></div>
                </template>
              </columnBookCards2>
            </swiper-slide>
          </swiper>
          <!-- <el-button
            class="l-btn"
            :icon="ArrowLeft"
            circle
            @click="rightClick_1"
          ></el-button>
          <el-button
            class="r-btn"
            :icon="ArrowRight"
            circle
            @click="leftClick_1"
          ></el-button> -->
        </div>
      </div>
      <div class="cyan-background" style="margin-bottom: 40px">
        <textBar :titles="getCategoryText(15) || ''"></textBar>
        <!-- 插件swiper区域-汇编类 -->
        <div class="box-columnBookCards">
          <swiper
            v-if="mydata.bookListData3.length"
            direction="horizontal"
            class="inside-cardBox"
            :slidesPerView="
              mydata.bookListData3.length >= 2 ? 2 : mydata.bookListData3.length
            "
            loop
            :autoplay="{ delay: 3000, disableOnInteraction: true }"
            :navigation="false"
            :pagination="{ clickable: true }"
            :scrollbar="{ draggable: true }"
            :space-between="0"
            :centeredSlides="false"
            :modules="modules_2"
            effect="coverflow"
            @swiper="onSwiper_2"
            @mouseenter="enter_2"
            @mouseleave="leave_2"
            @slideChange="onSlideChange_2"
            :slidesOffsetBefore="0"
            :slidesOffsetAfter="0"
            :spaceBetween="0"
          >
            <swiper-slide
              v-for="(item, index) in mydata.bookListData3"
              :key="index"
              style="margin: 0"
            >
              <columnBookCards2
                class="column-book3"
                :info="item"
                
              >
                <!-- <template #columnBook>
                  <img class="big-img" v-complete:src="item.img_url" alt="" />
                </template> -->
                <template #line>
                  <div
                    style="
                      width: 35px;
                      border: 1px solid #ffffff99;
                      margin: 10px 0px;
                    "
                  ></div>
                </template>
              </columnBookCards2>
            </swiper-slide>
          </swiper>
          <!-- <el-button
            class="l-btn"
            :icon="ArrowLeft"
            circle
            @click="rightClick_2"
          ></el-button>
          <el-button
            class="r-btn"
            :icon="ArrowRight"
            circle
            @click="leftClick_2"
          ></el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getBookListData } from "@/utils/commonApi.js";
// import modelTestsCard from "@/components/modelTestsCard/index.vue";
//图书分类接口
import { getCategoryList } from "@/api/bookIntro/index.js";
// import subjectButton from "@/components/subjectButton/index.vue";
import imgBigCards from "@/components/imgBigCards/index.vue";

import textBar from "@/components/textBar/index.vue";
import writingCardCarousel from "@/components/writingCardCarousel/index.vue";
import writingCardsBig from "@/components/writingCardsBig/index.vue";

// import columnBookCards2 from "@/components/columnBookCards2/index.vue";
import columnBookCards2 from "../components/columnBookCards2.vue";

import { nextTick, reactive, ref, toRaw } from "vue";
import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue";

//swiper start//////////////////////////////////////////////////////////////////////////////////////////////
// 引入swiper插件
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/modules";

// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 start////////////////
// 创建功能模块
let modules = [Autoplay, Navigation, Pagination, Scrollbar, A11y];
//定义swiperNew,目的获取非响应式swiper
let swiperNew = null;
// 事件处理器
const onSwiper = (swiper) => {
  swiperNew = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
//鼠标移入
const enter = () => {
  swiperNew.autoplay.stop();
};
//鼠标移出
const leave = () => {
  swiperNew.autoplay.start();
};
// 点击右箭头
const rightClick = () => {
  nextTick(() => {
    swiperNew.slidePrev();
  });
};
// 点击左箭头
const leftClick = () => {
  nextTick(() => {
    swiperNew.slideNext();
  });
};
// 单元块滑动
const onSlideChange = () => {};
// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 end////////////////

// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 start////////////////
// 创建功能模块
let modules_1 = [
  Autoplay,
  Navigation,
  // Pagination,
  Scrollbar,
  A11y,
];
//定义swiperNew,目的获取非响应式swiper
let swiperNew_1 = null;
// 事件处理器
const onSwiper_1 = (swiper) => {
  swiperNew_1 = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
//鼠标移入
const enter_1 = () => {
  swiperNew_1.autoplay.stop();
};
//鼠标移出
const leave_1 = () => {
  swiperNew_1.autoplay.start();
};
// 点击右箭头
const rightClick_1 = () => {
  nextTick(() => {
    swiperNew_1.slidePrev();
  });
};
// 点击左箭头
const leftClick_1 = () => {
  nextTick(() => {
    swiperNew_1.slideNext();
  });
};
// 单元块滑动
const onSlideChange_1 = () => {};
// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 end////////////////

// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 start////////////////
// 创建功能模块
let modules_2 = [
  Autoplay,
  Navigation,
  //Pagination,
  Scrollbar,
  A11y,
];
//定义swiperNew,目的获取非响应式swiper
let swiperNew_2 = null;
// 事件处理器
const onSwiper_2 = (swiper) => {
  swiperNew_2 = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
//鼠标移入
const enter_2 = () => {
  swiperNew_2.autoplay.stop();
};
//鼠标移出
const leave_2 = () => {
  swiperNew_2.autoplay.start();
};
// 点击右箭头
const rightClick_2 = () => {
  nextTick(() => {
    swiperNew_2.slidePrev();
  });
};
// 点击左箭头
const leftClick_2 = () => {
  nextTick(() => {
    swiperNew_2.slideNext();
  });
};
// 单元块滑动
const onSlideChange_2 = () => {};
// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 end////////////////

//swiper end//////////////////////////////////////////////////////////////////////////////////////////////

const mydata = reactive({
  bookListData1: [], //小学-总复习
  bookListData2: [], //小学-同步类
  bookListData3: [], //小学-汇编类
  getCategoryArr: [], //图书分类
  getCategoryArrId: [21, 16, 15],
});

//图书分类接口
function getCategoryFn() {
  getCategoryList().then((res) => {
    // console.log(res.data, "图书分类");
    mydata.getCategoryArr = res.data;
  });
}
getCategoryFn();

// 获取图书分类的文字
function getCategoryText(id) {
  let obj = mydata.getCategoryArr.find((item) => {
    return item.id === id;
  });
  return obj?.name;
}

// 小学-总复习
getBookListData(7, 21).then((res) => {
  // getBookListData().then((res) => {
  mydata.bookListData1 = res.data.list.map((item) => {
    item.path = item.buy_url_jd || item.buy_url;
    item.outPage = true;
    return item;
  });
});

// 小学-同步类
getBookListData(7, 16).then((res) => {
  // getBookListData().then((res) => {
  mydata.bookListData2 = res.data.list.map((item) => {
    item.path = item.buy_url_jd || item.buy_url;
    item.outPage = true;
    return item;
  });
});

// 小学-汇编类
getBookListData(7, 15).then((res) => {
  // getBookListData().then((res) => {
  mydata.bookListData3 = res.data.list.map((item) => {
    item.path = item.buy_url_jd || item.buy_url;
    item.outPage = true;
    return item;
  });
});
</script>

<style scoped lang="scss">
// :deep(.bookIntro > .box-green[data-v-4e942a3e] .swiper-button-prev::after){
//   background: red !important;
// }
.bookIntro {
  // background-color: #F7F7F7;
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }

  ////////青色区域
  > .box-cyan {
    width: 100%;
    // height: 661px;
    // border: 1px solid blue;
    // border:1px solid rgb(179, 255, 0);
    margin: 0 auto;
    background-color: #d8f5e1;
    background-color: #f9f9f9;
    // background-image: url("@/assets/Rectangle 1131.png");
    overflow: hidden;
    ///////装图书组件 和 按钮的大盒子
    .cyan-background {
      // border: 1px solid red;
      width: 343px;
      // height: 565px;
      // border: 1px solid rgb(179, 255, 0);
      margin: 0 auto;
      // border: 1px solid #031402;
      margin-top: 24px;
      margin-top: 0px;
      // margin-bottom:30px;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;

      //////装按钮的区域
      .box-button {
        width: 100%;
        margin-bottom: 16px;
        // border: 1px solid red;
        display: flex;
        justify-content: space-between;
        .box-itemButton {
          width: 74px;
          // border: 1px solid blue;
          display: flex;
          justify-content: center;
          :deep(.el-button.el-button--success) {
            width: 74px;
            height: 31px;
            // border: 1px solid blue;
            // margin:0 auto !important;
            > span {
              font-size: 14px;
              font-weight: 400;
            }
          }
        }
      }
      //////装所有图书卡片组件的区域
      .box-columnBookCards {
        height: 298px;
        display: flex;
        justify-content: space-between;
        position: relative;
        // overflow: hidden;
        // border: 1px solid red;
        //////图书卡片组件
        :deep(.column-book3) {
          width: 168px;
          // width: 100%;

          // height: 485px;
          // height: 473px;
          border-radius: 8px;
          //border: 1px solid blue;
          // margin: 0 7px;

          width: 95%;
          margin: 0 auto;
          /* 
          
          思路：
          1、给swiper组件设置三个属性
          :slidesOffsetBefore="0"
          :slidesOffsetAfter="0"
          :spaceBetween="0"
          这样的话，swiper-slide就会完全充满swiper-wrapper与swiper，没有任何缝隙
          2、给swiper-slide里面的根元素设置宽度width:85%;margin:0 auto;这样就会出现视觉上的空白区域，并且因为外边距样式而居中。
          
          */

          flex-shrink: 0;
          overflow: hidden; /* 确保超出容器的内容被裁剪 */
          // white-space: nowrap; /* 确保文本在一行内显示 */
          text-overflow: ellipsis; /* 超出部分显示省略号 */
          .back-box {
            width: 163px;
            height: 163px;
            .big-img {
              // width: 165px;
              // margin-left:70px;
              // margin-top:45px;
            }
          }
          .box-content {
            // width: 285px;
            height: 140px !important;
            // background: linear-gradient(180deg, #5fba45 24.06%, #c7db0f 100%);
            //background: linear-gradient(180deg, #5fba45 24.06%, #c7db0f 100%);
            background: linear-gradient(180deg, #f54532 10.06%, #fff201 100%);
            padding: 10px;
            margin-top: -5px;
            // width: 100%;

            > p:nth-of-type(1) {
              font-size: 16px;
              // font-weight: 700;
              color: #ffffff;
              // display: block;
              // letter-spacing: 1px;
            }
            > p:nth-of-type(2) {
              font-size: 14px;
              font-weight: 400;
              color: #ffffff;
              line-height: 22px;
              display: -webkit-box;
              -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
              text-overflow: ellipsis; //文本溢出 用省略号显示
              -webkit-line-clamp: 5; //几行
              overflow: hidden;
            }
          }
        }

        :deep(.swiper-button-prev::after) {
          margin-left: -18px;
          color: #87968c;
          font-size: 20px;
          margin-top: 0px;
          border: 1px solid #87968c;
          width: 25px;
          height: 25px;
          border-radius: 100%;
          line-height: 25px;
          text-align: center;
        }
        :deep(.swiper-button-next::after) {
          margin-right: -20px;
          color: #87968c;
          font-size: 20px;
          margin-top: 0px;
          border: 1px solid #87968c;
          width: 25px;
          height: 25px;
          border-radius: 100%;
          line-height: 25px;
          text-align: center;
        }

        .l-btn {
          position: absolute;
          z-index: 9999;
          color: #87968c;
          font-size: 20px;
          border: 1px solid #87968c;
          width: 25px;
          height: 25px;
          border-radius: 100%;
          line-height: 25px;
          text-align: center;
          top: 40%;
          left: 0px;
          background: transparent;
          z-index: 4;
        }

        .r-btn {
          position: absolute;
          z-index: 9999;
          color: #87968c;
          font-size: 20px;
          border: 1px solid #87968c;
          width: 25px;
          height: 25px;
          border-radius: 100%;
          line-height: 25px;
          text-align: center;
          top: 40%;
          right: 0px;
          background: transparent;
          z-index: 4;
        }
      }
    }

    :deep(.swiper-wrapper) {
      // border: 1px solid rgb(255, 0, 242);
      // margin:0 auto;

      width: 1250;
      height: 484px;
      // margin-top:100px;
    }
  }
}
:deep(.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal){
  display: none;
}


</style>
